import { makeModelMixin } from '../utils/model';

const {
  mixin,
  props,
  prop,
  event
} = makeModelMixin('value');

export { event as MODEL_EVENT_NAME, prop as MODEL_PROP_NAME, mixin as modelMixin, props };
